import { ClaudeTemplate } from "../types";

/** Outbrain (NATADS con proveedor OUTBRAIN). */
export const outbrainTemplate: ClaudeTemplate = {
  id: "outbrain",
  tool: "Outbrain",
  url: "https://my.outbrain.com/",
  hierarchy:
    "Marketer (cuenta) → Campaign → Ads (imagen o vídeo + título + URL)",
  idHint:
    "ID de la campaña en la URL o en la columna ID del listado de campañas",
  accountField: "outbrainAccountIds",
  steps: `
### 1. Entrar en la cuenta (puede que ya estés dentro)
1. Abre Outbrain ({{url}}). Si ya está abierto, sigue.
2. Elige la cuenta (marketer) del cliente {{client}}. ID(s) conocidos: {{accountIds}}. Si no hay ID, búscala por nombre; si hay varias, pregunta.

### 2. Campaign
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, crea una nueva:
   - Name: {{names.order}}
   - Objective: el que encaje con {{goal.kpi}} (CPC → Traffic; CPM → Awareness; CPV → Video views; CPA/CPL → Conversions).
   - Fechas: {{goal.startDate}} → {{goal.endDate}}.
   - Budget: {{goal.budget}} para todo el periodo (campaign budget total, no diario, si se puede elegir). Si solo deja diario, reparte el total entre los días y dímelo.
   - Puja: CPC (o el modelo que corresponda) en torno a {{goal.netUnitCost}}. Si la herramienta propone estrategia automática, pregunta antes de cambiar la puja fija.
3. Targeting:
   - Location: {{target.geography}} (país {{goal.country}}).
   - Platform / devices: {{target.technology}}.
   - Language: {{target.language}}.
   - Audiencias e intereses: {{target.audience}} / {{target.interests}}.
   - Bloqueo de sites / exclusiones: {{target.exclusions}}.
4. Tracking: añade los parámetros UTM de la URL de destino (bloque "URLs de destino") en el campo de tracking / sufijo de URL.
5. Guarda la campaña **en pausa**.

### 3. Ads
1. Tipo de anuncio según el tipo de campaña {{campaignType}}: NATADS_COMERCIAL / NATADS_EDITORIAL → imagen + título; VIDEO_NATADS → vídeo; CARROUSEL → carrusel si la cuenta lo tiene disponible.
2. Para cada creatividad del bloque "Creatividades", crea un anuncio con su imagen o vídeo, el título y la descripción del bloque "Copies", el nombre de marca {{brand}} y la URL de destino con UTM.
3. Si hay más imágenes que títulos (o al revés), combínalos como tenga sentido y dímelo.
4. Guarda sin activar. Los anuncios pasan por revisión de Outbrain: es normal.
`,
};
